import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocaleService, OptimService,ConfigurationService, Popr2Service, Popr2Level, Popr2Priority } from '@ciam/library';
import { Observable, take, EMPTY, catchError } from 'rxjs';
import { concatMap, defaultIfEmpty, filter, finalize, switchMap } from 'rxjs/operators';
import { LoginInfoService } from 'src/app/services/login-info/login-info.service';
import { MFAPreferencesService } from 'src/app/services/mfaPreferences/mfaPreferences.service';
import { MFAPreferencesResponse } from 'src/app/shared/models/MFAPreferencesResponse';
import { GdlService } from 'src/app/shared/services/gdl-service/gdl.service';
import { WindowRef } from 'src/app/util/window.ref';
import { PoprPriority } from '../../../shared/components/popr/popr-priority.enum';
import { PoprService } from '../../../shared/components/popr/popr.service';
import { TwoFactorComponent } from '../../../shared/components/two-factor/two-factor.component';
import { FormElementConfig } from '../../../shared/models/FormElementConfig';
import { APIResponse, PhoneNumberDetails } from '../../../shared/models/LoginInfoResponse';
import { DeliveryChannelPreferences } from '../../../shared/models/MFAPreferencesResponse';
import { SessionStorageService } from '../../../shared/services/sessionStorage-service/session-storage.service';
import { SharedService } from '../../../shared/services/shared-service/shared.service';
import { VerificationMethodComponent } from 'src/app/shared/components/verify-identity/verification-method/verification-method.component';
import { VerifyIdentityComponent } from 'src/app/shared/components/verify-identity/verify-identity.component';
import { TwoSteptogglePopupComponent } from '../two-steptoggle-popup/two-steptoggle-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { PinRequest } from 'src/app/shared/services/mfa-pin/APIResponse';
import { MfaPinService } from 'src/app/shared/services/mfa-pin/mfa-pin.service';
import { EnterPinComponent } from 'src/app/shared/components/verify-identity/enter-pin/enter-pin.component';
import { bind } from 'lodash';

export enum PARAMS {
  MOCK = 'mock',
  DEFAULT_DELIVERY_METHOD = 'deliverymethod'
}

@Component({
  selector: 'wpro-two-stepverification',
  templateUrl: './two-stepverification.component.html',
  standalone: false
})
export class TwoStepverificationComponent implements OnInit, AfterViewInit {
  private readonly ERROR_CODE_400 = 400;
  gdlServerType = 'server';
  gdlContextPutType = 'PUT';
  gdlContextGetType = 'GET';
  gdlMfaLogin = '2fa-login';
  gdlMfaLocation = '2fa-location';
  gdlMfaSwitchOn = 'ON';
  gdlMfaSwitchOff = 'OFF';
  gdlVerifyIdentity='loginsecurity-2fa-verifyidentity-modal';
  gdlVerifyIdentityClose = 'wpro-loginsecurity-2fa-verifyidentity-modal';
  gdlModal = 'modal';
  gdlOpen ='open';
  gdlClose ='dismiss';
  termsAndConditionUrl: string;
  twoStepVerifyForm: UntypedFormGroup;
  textMsgDropdownControl: UntypedFormControl;
  phoneCallDropdownControl: UntypedFormControl;
  contactDetails: DeliveryChannelPreferences[];
  phoneCode = '';
  primaryPhoneNumber: string;
  secondaryPhoneNumber: string;
  textMsgNumberSelected = '';
  phoneCallNumberSelected = '';
  textDropdownConfig: FormElementConfig;
  phoneDropdownConfig: FormElementConfig;
  @Input() twosvFlag: boolean;
  @Output() hideDefaultverifyandTrustedDevice= new EventEmitter<boolean>();
  @Output() hideSuccessNotificationPopup = new EventEmitter<boolean>();
  @Output() hideNotificationPopup = new EventEmitter<any>();
  @Output() closeLoginEdit = new EventEmitter<boolean>();
  @Output() continueVerifyFlow = new EventEmitter<boolean>();
  defaultMfaOnLogin = false;
  defaultLocationRestricition = false;
  isAPIFailLoginScreen = false;
  showPopUp = false;
  restrictionFlag = false;
  deliveryType = '';
  deliveryTypeOld: string;
  gdlDeliveryType = '';
  locationRestrictionClicked = false;
  twoStepVerificationClicked = false;
  mfaFlag = false;
  defaultDeliveryMethod: DeliveryChannelPreferences[];
  contactlinckclicked: boolean;
  /* Todo: Revisit once @Input is added to the Two-Factor component */
  isTwoStepVerification: boolean;
  isLocationRestriction: boolean;
  //B-999556 update secondry phone number prefecence for MFA
  isPhoneNumLoading = false;
  isDecoupleSecondaryPhone: boolean;
  isDecoupleTwoFAEdit: boolean;
  textMsgSelectedLabel: string;
  phoneCallSelectedLabel: string;
  isTwoSVToggleLoading = true;
  deliveryMethod: string;
  verifyPinRequest: PinRequest;

  @ViewChild('twoFactorElevationFailure', { read: TemplateRef })
  twoFactorFailureTemplate!: TemplateRef<any>;
  personalEmail: any;
  countryCode: string;
  locRestriction = false;
  twoFaChannelVerify = false;
  isTwoFAEnabled=false;

  constructor(public mfaPreferencesService: MFAPreferencesService,
              public fb: UntypedFormBuilder,
              private configService: ConfigurationService,
              private localeService: LocaleService,
              public sharedService: SharedService,
              private sessionStorageService: SessionStorageService,
              private poprService: PoprService,
              private popr2Service: Popr2Service,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private gdlService: GdlService,
              public loginService: LoginInfoService,
              private optimService: OptimService,
              private el: ElementRef,
              @Inject(DOCUMENT) private _document: any,
              private translateService: TranslateService,
              private sendPinService: MfaPinService) {
  }

  ngOnInit(): void {
    this.optimService.decide$('location_restriction').subscribe(result => this.locRestriction = result.enabled);
    this.optimService.decide$('2fa_channel_verify').subscribe(result => this.twoFaChannelVerify = result.enabled);

    this.twoStepVerifyForm = this.fb.group({
      mfaOnLogin: false,
      restrictOutsideCountryLogin: false,
      deliveryChannelPreference: ''
    });

    this.textMsgDropdownControl = new UntypedFormControl();
    this.phoneCallDropdownControl = new UntypedFormControl();

    this.textDropdownConfig = {
      id: 'smsDropdown',
      label: 'smsDropdown-label',
      name: 'smsNumbersList'
    };

    this.phoneDropdownConfig = {
      id: 'callDropdown',
      label: 'callDropdown-label',
      name: 'callNumbersList'
    };
    this.optimService.decide$('wpro_2fa_on_edit', { country: `${this.localeService.solveLocale().country}` }).subscribe((result) => {
    //this.isDecoupleSecondaryPhone = this.configService.select<boolean>('secondaryPhoneNumberDecoupleFlag');
    if (result.enabled) {
      this.isDecoupleSecondaryPhone = false;
      this.isDecoupleTwoFAEdit = false;
      }else{
        this.isDecoupleSecondaryPhone = true;
        this.isDecoupleTwoFAEdit = true;
      }
    window.scroll(0, 0);
   // this.isDecoupleTwoFAEdit = this.configService.select<boolean>('twoFactorEditDecoupleFlag');
    this.mfaPreferencesAPI();
  });
  }

  fetchUserDetails(event?: any): void {
    // Read defensively: the shared apiResponse subject may hold a value without
    // `output` (transient/late empty emission), so never dereference blindly.
    const phoneNumberDetails: PhoneNumberDetails[] =
      this.sharedService.apiResponse?.output?.userProfile?.userProfileAddress?.contactAncillaryDetail?.phoneNumberDetails;
    this.countryCode = phoneNumberDetails?.[0]?.number?.countryCode ?? '';
    this.primaryPhoneNumber = phoneNumberDetails?.[0]?.number?.localNumber;
    if (event && event.isSuccess && event.secondaryNumberDetails && phoneNumberDetails?.[1]?.number) {
      phoneNumberDetails[1].number.countryCode = event.secondaryNumberDetails.secondaryPhoneCountryCode;
      phoneNumberDetails[1].number.localNumber = event.secondaryNumberDetails.secondaryPhoneNumber;

      this.secondaryPhoneNumber = event.secondaryNumberDetails.secondaryPhoneNumber;

      this.textMsgNumberSelected = `+${this.countryCode} ${this.primaryPhoneNumber}`;
      this.textMsgDropdownControl.setValue('PHONE');
      this.textMsgSelectedLabel = 'phoneNumber.primaryPhoneNumber';
      this.phoneCallNumberSelected = `+${this.countryCode} ${this.primaryPhoneNumber}`;
      this.phoneCallDropdownControl.setValue('PHONE');
      this.phoneCallSelectedLabel='phoneNumber.primaryPhoneNumber';
    }

    // Only react to emissions that actually carry `output`; a null or empty
    // (no-output) emission must not throw or overwrite the resolved phone code.
    this.sharedService.userInfoResponse$.pipe(filter(data => !!data?.output)).subscribe((data: APIResponse) => {
      const details: PhoneNumberDetails[] = data.output.userProfile?.userProfileAddress?.contactAncillaryDetail?.phoneNumberDetails;
      this.countryCode = details?.[0]?.number?.countryCode ?? '';
      this.phoneCode = `+${this.countryCode}`;
    });
  }

  mfaPreferencesAPI(): void {
    let queryParams = {};
    this.activatedRoute.queryParamMap
      .subscribe((params) => {
        queryParams = params;
      });

      this.mfaPreferencesService.getUserMFAPreferences(true).subscribe(
        (response) => {
          this.contactDetails = response.output.deliveryChannelPreferences;
          this.sharedService.mfaChannelsList = this.contactDetails;
          this.isTwoSVToggleLoading = false;
          this.fetchUserDetails();
          this.populateDefaultDeliveryValues(response);
          //B-676133, declaring at class level to get the state of value when Cancel button clicked on continue popup
          this.defaultMfaOnLogin = response.output.mfaOnLogin;
          this.isTwoFAEnabled= response.output.mfaOnLogin;
          this.hideDefaultverifyandTrustedDevice.emit(this.isTwoFAEnabled);
          this.sessionStorageService.setItem('mfaToggleStatus', this.defaultMfaOnLogin);
          this.sessionStorageService.setItem('deliveryChannelPreference', response.output.preferredDeliveryMethod);
          this.defaultLocationRestricition = response.output.restrictOutsideCountryLogin;
          this.twoStepVerifyForm.patchValue({ mfaOnLogin: response.output.mfaOnLogin });
          this.twoStepVerifyForm.patchValue({ restrictOutsideCountryLogin: response.output.restrictOutsideCountryLogin });
          response.output?.deliveryChannelPreferences.filter((channel: any) => channel.primaryDeliveryMethod === true)
          .map((item: any) => this.deliveryMethod = item.deliveryMethod);
        },
        (error) => {
          this.isAPIFailLoginScreen = true;
          // GDL will triggeers incase of server validation error
          this.gdlService.captureGdlErrorMessages(this.gdlServerType, error, this.gdlContextGetType);
        }
      );


  }


  populateDefaultDeliveryValues(response: MFAPreferencesResponse): void {
    if (this.isDecoupleTwoFAEdit) {
      this.defaultDeliveryMethod = this.contactDetails.filter(
        preference => preference.primaryDeliveryMethod
      );
      this.patchDeliveryChannelPreference(this.defaultDeliveryMethod[0].deliveryMethod);
      this.populateV1PhoneNumberValues();
    }else{
      this.patchDeliveryChannelPreference(response.output.preferredDeliveryMethod);
      this.populateV3PhoneNumberValues();
    }
  }

  patchDeliveryChannelPreference(preference: string): void {
    this.twoStepVerifyForm.patchValue({ deliveryChannelPreference: preference });
  }

  populateV1PhoneNumberValues(): void {
    const callMethod = this.contactDetails.find(data => data.deliveryMethod === 'CALL');
    const smsMethod =  this.contactDetails.find(data => data.deliveryMethod === 'SMS');

    const phoneNumber = callMethod !== undefined ? callMethod.value : smsMethod?.value;

    if (phoneNumber) {
      this.phoneCallNumberSelected = `+${this.countryCode} ${phoneNumber}`;
      this.phoneCallDropdownControl.setValue('PHONE');

      this.textMsgNumberSelected = `+${this.countryCode} ${phoneNumber}`;
      this.textMsgDropdownControl.setValue('PHONE');
    }
  }
  populateV3PhoneNumberValues(): void {
    this.personalEmail = this.contactDetails[0].deliveryMethods.find(data => data.type === 'PERSONALEMAIL');

    const callDeliveryMethods = this.contactDetails.find(data => data.deliveryMethod === 'CALL');
    const textDeliveryMethods = this.contactDetails.find(data => data.deliveryMethod === 'SMS');

    if(callDeliveryMethods !== undefined && textDeliveryMethods === undefined) {
      this.populateCallPhoneNumberValues(callDeliveryMethods);
    } else if(callDeliveryMethods === undefined && textDeliveryMethods !== undefined) {
      this.populateSmsPhoneNumberValues(textDeliveryMethods);
    } else {
      this.populateDelMethodsPhoneNumbersValues(callDeliveryMethods, textDeliveryMethods);
    }
  }

  populateCallPhoneNumberValues(callDeliveryMethods: any): void {
    const primaryNumber = callDeliveryMethods.deliveryMethods.find(data => data.type === 'PHONE');
    const secondaryNumber = callDeliveryMethods.deliveryMethods.find(data => data.type === 'MOBILE');

    this.primaryPhoneNumber = primaryNumber.value;

    if(secondaryNumber !== undefined) {
      this.secondaryPhoneNumber = secondaryNumber.value;
    }

    const isCallDeliveryTypePhone = callDeliveryMethods.preferredDeliveryType === primaryNumber.type;

    this.phoneCallNumberSelected = isCallDeliveryTypePhone ?
      `+${this.countryCode} ${this.primaryPhoneNumber}` : `+${this.countryCode} ${this.secondaryPhoneNumber}`;

    this.phoneCallSelectedLabel = isCallDeliveryTypePhone ?
      'phoneNumber.primaryPhoneNumber' : 'phoneNumber.secondaryPhoneNumber';

    isCallDeliveryTypePhone ? this.phoneCallDropdownControl.setValue('PHONE') :
      this.phoneCallDropdownControl.setValue('MOBILE');
  }

  populateSmsPhoneNumberValues(textDeliveryMethods: any): void {
    const primaryNumber = textDeliveryMethods.deliveryMethods.find(data => data.type === 'PHONE');
    const secondaryNumber = textDeliveryMethods.deliveryMethods.find(data => data.type === 'MOBILE');

    this.primaryPhoneNumber = primaryNumber.value;

    if(secondaryNumber !== undefined) {
      this.secondaryPhoneNumber = secondaryNumber.value;
    }

    const isTextDeliveryTypePhone = textDeliveryMethods.preferredDeliveryType === primaryNumber.type;

    this.textMsgNumberSelected = isTextDeliveryTypePhone ?
      `+${this.countryCode} ${this.primaryPhoneNumber}` : `+${this.countryCode} ${this.secondaryPhoneNumber}`;

    this.textMsgSelectedLabel = isTextDeliveryTypePhone ?
      'phoneNumber.primaryPhoneNumber' : 'phoneNumber.secondaryPhoneNumber';

    isTextDeliveryTypePhone ? this.textMsgDropdownControl.setValue('PHONE') :
      this.textMsgDropdownControl.setValue('MOBILE');
  }

  populateDelMethodsPhoneNumbersValues(callDeliveryMethods: any, textDeliveryMethods: any): void {
    const callPrimaryNumber = callDeliveryMethods.deliveryMethods.find(data => data.type === 'PHONE');
    const callSecondaryNumber = callDeliveryMethods.deliveryMethods.find(data => data.type === 'MOBILE');
    const smsPrimaryNumber = textDeliveryMethods.deliveryMethods.find(data => data.type === 'PHONE');
    const smsSecondaryNumber = textDeliveryMethods.deliveryMethods.find(data => data.type === 'MOBILE');

    this.primaryPhoneNumber = callPrimaryNumber.value === smsPrimaryNumber.value ? callPrimaryNumber.value : smsPrimaryNumber.value;

    if(callSecondaryNumber !== undefined && smsSecondaryNumber !== undefined) {
      this.secondaryPhoneNumber = callSecondaryNumber.value === smsSecondaryNumber.value ? callSecondaryNumber.value : smsSecondaryNumber.value;
    }

    const isCallDeliveryTypePhone = callDeliveryMethods.preferredDeliveryType === callPrimaryNumber.type;

    this.phoneCallNumberSelected = isCallDeliveryTypePhone ?
      `+${this.countryCode} ${this.primaryPhoneNumber}` : `+${this.countryCode} ${this.secondaryPhoneNumber}`;

    this.phoneCallSelectedLabel = isCallDeliveryTypePhone ?
      'phoneNumber.primaryPhoneNumber' : 'phoneNumber.secondaryPhoneNumber';

    isCallDeliveryTypePhone ? this.phoneCallDropdownControl.setValue('PHONE') :
      this.phoneCallDropdownControl.setValue('MOBILE');

    const isTextDeliveryTypePhone = textDeliveryMethods.preferredDeliveryType === smsPrimaryNumber.type;

    this.textMsgNumberSelected = isTextDeliveryTypePhone ?
      `+${this.countryCode} ${this.primaryPhoneNumber}` : `+${this.countryCode} ${this.secondaryPhoneNumber}`;

    this.textMsgSelectedLabel = isTextDeliveryTypePhone ?
      'phoneNumber.primaryPhoneNumber' : 'phoneNumber.secondaryPhoneNumber';

    isTextDeliveryTypePhone ? this.textMsgDropdownControl.setValue('PHONE') :
      this.textMsgDropdownControl.setValue('MOBILE');
  }

  termsAndConditionClick($event: any): void {
    this.termsAndConditionUrl = `https://${this.configService.select('env.host')}${this.configService.select('links.termsAndConditionsUrl')}`;
    this.localeService.interpolate(this.termsAndConditionUrl).then((value) => {
      this.termsAndConditionUrl = value;
      if ($event.target.className.indexOf('termsAndConditions') >= 0) {
        this.openUrl(this.termsAndConditionUrl);
      }
     });
  }
  contactInfoClick(event?: Event): void {
    if (event) {
      const target = event.target as Element | null;
      const contactInfoLink = target?.closest('a.contactInformation');
      if (!contactInfoLink) {
        return;
      }
    }
    if (!this.sharedService.isEditScreen) {
      this.sharedService.setSelectedRoute('contact');
      this.router.navigate(['/contact']);
    } else {
      this.contactlinckclicked = true;
      // B-676133,show continue popup in edit mode
      this.showPopUp = this.sharedService.isEditScreen;
      const maxWidth = 768;
      if (screen.width < maxWidth) {
        this.sharedService.isModalPopupOpen = true;
        this._document.body.style.overflow = 'hidden';
      }
    }
  }
  openUrl(url: string): void {
    WindowRef.nativeWindow.open(url, '_blank');
  }

  toggleMfaCheck(event: any): void {
    // B-676133, get the state of toggle button and save at class level variable
    if (event != null && event.target != null) {
      this.mfaFlag = (event.target as HTMLInputElement).checked;
      (event.target as HTMLInputElement).checked = !(event.target as HTMLInputElement).checked;
    }

    this.isTwoSVToggleLoading = this.mfaFlag;

    this.twoFaChannelVerify && this.mfaFlag ? this.toggleMfaOn() : this.twoFaChannelVerify? this.showTwoFATogglePopup() : this.changeMFAOnLogin();
  }

  showTwoFATogglePopup(): void{
    const poprRef = this.popr2Service.createModal(
      TwoSteptogglePopupComponent,
      { priority: Popr2Level.NONE, dimension: '.fdx-c-dialog--narrow.fdx-c-dialog--condensed' }
    );
    let toast = false;
    poprRef.open((comp: TwoSteptogglePopupComponent) => {
      comp.twoFaContinue.subscribe((twoFAContinue) => {
        if (twoFAContinue) {
          this.changeMFAOnLogin();
          toast = true;
        }
        poprRef.close();
        let errorMsg = '';
        this.translateService.get('errorNotification.sysUnavailToastMsg').subscribe((translatedMsg) => {
          errorMsg = translatedMsg;
        });
        if (!toast) {
          this.popr2Service.createToast(errorMsg, {
            priority: Popr2Level.ERROR
          }).open();
        }
      });
      comp.twoFaHidePopup.subscribe((twoFaHidePopup) => {
        if (twoFaHidePopup) {
          toast = false;
          poprRef.close();
          this.mfaFlag=false;
        }
      });
    });
  }

  toggleMfaOn(): void {
    const poprRef = this.popr2Service.createModal(
      VerifyIdentityComponent,
      { priority: Popr2Level.NONE, dimension: '.fdx-c-dialog--narrow.fdx-c-dialog--condensed' }
    );
    let queryParams = {};
    this.activatedRoute.queryParamMap
    .subscribe((params) => {
      queryParams = params;
    });

    let errorMsg;
    const popr2Level = Popr2Level.ERROR;
    poprRef.registerOnClose(() => {
      this.translateService.get('errorNotification.twoStepVerificationClose').subscribe((translatedMsg) => {
        errorMsg = translatedMsg;
      });
      this.toastMessage2SV(errorMsg, popr2Level);
      //GDL for Modal Close by Cross Icon for Verify Indentity Popup
      this.gdlService.triggerGdlLogEvent(this.gdlModal,this.gdlClose, { name: this.gdlVerifyIdentityClose });
    });
    poprRef.open((comp: VerifyIdentityComponent) => {
      this.gdlService.triggerGdlLogEvent(this.gdlModal,this.gdlOpen, { name: this.gdlVerifyIdentity });
      this.isTwoSVToggleLoading = false;
      comp.verified.subscribe((verified) => {
        this.deliveryMethod = comp.deliveryMethod;
        this.translateService.get('errorNotification.twoStepVerificationClose').subscribe((translatedMsg) => {
          errorMsg = translatedMsg;
        //GDL for Modal Close by Cancel button for Verify Indentity Popup
        this.gdlService.triggerGdlLogEvent(this.gdlModal,this.gdlClose, { name: this.gdlVerifyIdentityClose });
        });
        (verified) ? this.updateMfaOnLogin() : this.toastMessage2SV(errorMsg, popr2Level);
        poprRef.close();
      });
    });
  }

  toastMessage2SV(message: string, poprLevel: Popr2Priority): void {
    this.popr2Service.createToast(message, {
      priority: poprLevel
    }).open();
  }

  changeMFAOnLogin(): void {
    this.isTwoStepVerification = true;
    this.isLocationRestriction = false;
    // B-676133,identify button click, so that repective method can be called while continuing on popup
    this.twoStepVerificationClicked = true;
    // B-676133,show continue popup in edit mode
    this.showPopUp = this.sharedService.isEditScreen;

    if (!this.sharedService.isEditScreen) {
      this.updateMfaOnLogin();
    } else {
      const maxWidth = 768;
      if (screen.width < maxWidth) {
        this.sharedService.isModalPopupOpen = true;
        this._document.body.style.overflow = 'hidden';
      }
    }
  }

  updateMfaOnLogin(): void {
    let queryParams = {};
    this.activatedRoute.queryParamMap
      .subscribe((params) => {
        queryParams = params;
      });

    this.mfaPreferencesService.updateMFAOnLogin(this.mfaFlag, queryParams).pipe().subscribe(() => {
      this.isTwoSVToggleLoading = false;
      this.twoStepVerifyForm.patchValue({ mfaOnLogin: this.mfaFlag });
      let successMsg;
      const messageKey = this.mfaFlag ? 'successNotification.twoSVSuccessDescription': 'successNotification.twoSVDisableDescription';
      this.translateService.get(messageKey).subscribe((translatedMsg) => {
        successMsg = translatedMsg;
      });
      this.toastMessage2SV(successMsg, Popr2Level.SUCCESS);
      // this.sharedService.isMfaPreferenceEnabled = this.mfaFlag;
      this.sessionStorageService.setItem('mfaToggleStatus', this.mfaFlag);
      this.isTwoStepVerification = false;
      this.isTwoFAEnabled=this.mfaFlag;
      this.hideDefaultverifyandTrustedDevice.emit(this.mfaFlag);
      const mfaLogin = this.twoStepVerifyForm.controls['mfaOnLogin'].value ? this.gdlMfaSwitchOn : this.gdlMfaSwitchOff;
      this.gdlService.captureInteractionEvent(this.gdlMfaLogin, mfaLogin);
      this.patchDeliveryChannelPreference(this.deliveryMethod);
    }, (httpError) => {
      this.twoStepVerifyForm.patchValue({ mfaOnLogin: !this.mfaFlag });
      this.handleError(httpError, '2stepVerification');
      // GDL will triggeers incase of server validation error
      this.gdlService.captureGdlErrorMessages(this.gdlServerType, httpError, this.gdlContextPutType);
    });
  }

  changeLocationRestriction(event: any): void {
    // B-676133,identify button click, so that repective method can be called while continuing on popup
    this.locationRestrictionClicked = true;
    // B-676133, get the state of toggle button and save at class level variable
    if (event != null && event.target != null) {
      this.restrictionFlag = (event.target as HTMLInputElement).checked;
      (event.target as HTMLInputElement).checked = !(event.target as HTMLInputElement).checked;
    }
    this.isLocationRestriction = true;
    this.isTwoStepVerification = false;
    // B-676133,show continue popup in edit mode
    this.showPopUp = this.sharedService.isEditScreen;

    if (!this.sharedService.isEditScreen) {
      let queryParams = {};
      this.activatedRoute.queryParamMap
        .subscribe((params) => {
          queryParams = params;
        });
      this.mfaPreferencesService.restrictOutsideCountryLogin(this.restrictionFlag, queryParams).subscribe(() => {
        this.twoStepVerifyForm.patchValue({ restrictOutsideCountryLogin: this.restrictionFlag });
        const locationRestriction = this.twoStepVerifyForm.controls['restrictOutsideCountryLogin'].value ? this.gdlMfaSwitchOn : this.gdlMfaSwitchOff;
        this.gdlService.captureInteractionEvent(this.gdlMfaLocation, locationRestriction);

        this.isLocationRestriction = false;
      }, (httpError) => {
        this.twoStepVerifyForm.patchValue({ restrictOutsideCountryLogin: !this.restrictionFlag });
        this.handleError(httpError, '2stepVerification');
        // GDL will triggeers incase of server validation error.
        this.gdlService.captureGdlErrorMessages(this.gdlServerType, httpError, this.gdlContextPutType);
      });
    } else {
      const maxWidth = 768;
      if (screen.width < maxWidth) {
        this.sharedService.isModalPopupOpen = true;
        this._document.body.style.overflow = 'hidden';
      }
    }
  }

  changeMFAPrefrenceType(deliveryType: string): void {
    // B-676133,show continue popup in edit mode
    this.showPopUp = this.sharedService.isEditScreen;
    // B-676133,set delivery type, so that same can be passed while continuing on popup
    this.deliveryType = deliveryType;
    if (!this.sharedService.isEditScreen) {
      // B-2116732, revalidate mfa
      if (this.twoFaChannelVerify) {
        this.revalidateMfa();
      } else {
        this.mfaPreferencesService.updateUserMFAPreferences(deliveryType).subscribe(
          () => {
            this.gdlService.captureInteractionEvent('verification', deliveryType);
            this.hideSuccessNotificationPopup.emit(true);
            this.sessionStorageService.setItem('deliveryChannelPreference', this.deliveryType);
            this.patchDeliveryChannelPreference(this.deliveryType);
            this.deliveryMethod = deliveryType;
          }, (httpError) => {
            this.handleError(httpError, 'deliveryPreference');
            // GDL will triggeers incase of server validation error.
            this.gdlService.captureGdlErrorMessages(this.gdlServerType, httpError, this.gdlContextPutType);
            this.deliveryTypeOld = (this.sessionStorageService.getItem('deliveryChannelPreference')).toString();
            this.patchDeliveryChannelPreference(this.deliveryTypeOld);
          });
      }
    } else {
      const maxWidth = 768;
      if (screen.width < maxWidth) {
        this.sharedService.isModalPopupOpen = true;
        this._document.body.style.overflow = 'hidden';
      }
      this.deliveryTypeOld = (this.sessionStorageService.getItem('deliveryChannelPreference')).toString();
      this.patchDeliveryChannelPreference(this.deliveryTypeOld);
    }
  }

  //B-999556 update secondry phone number prefecence for MFA
  changeMFAPreferencePhoneType(selectedPhoneType: string, deliveryChannelPreference: string): void {
    this.isPhoneNumLoading = true;

    const selectedPhoneNumber = selectedPhoneType === 'PHONE' ? `+${this.countryCode} ${this.primaryPhoneNumber}`:
      `+${this.countryCode} ${this.secondaryPhoneNumber}`;

    let queryParams = {};
    this.activatedRoute.queryParamMap.subscribe((params) => {
      queryParams = params;
    });

    this.mfaPreferencesService.updatePhoneNumForMFAPrefrenceType(selectedPhoneType, deliveryChannelPreference, queryParams)
      .subscribe(
        () => {
          this.gdlService.captureInteractionEvent('verification', selectedPhoneType);
          this.hideSuccessNotificationPopup.emit(true);

          if(deliveryChannelPreference === 'SMS') {
            this.textMsgSelectedLabel = selectedPhoneType === 'PHONE' ?
              'phoneNumber.primaryPhoneNumber' : 'phoneNumber.secondaryPhoneNumber';
            this.textMsgNumberSelected = selectedPhoneNumber;
          } else {
            this.phoneCallSelectedLabel = selectedPhoneType === 'PHONE' ?
              'phoneNumber.primaryPhoneNumber' : 'phoneNumber.secondaryPhoneNumber';
            this.phoneCallNumberSelected = selectedPhoneNumber;
          }

          this.isPhoneNumLoading = false;
        }, (httpError) => {
          this.handleError(httpError, 'deliveryPreference');
          this.gdlService.captureGdlErrorMessages(this.gdlServerType, httpError, this.gdlContextPutType);

          if (deliveryChannelPreference === 'SMS') {
            this.textMsgSelectedLabel = selectedPhoneType === 'MOBILE' ?
              'phoneNumber.primaryPhoneNumber' : 'phoneNumber.secondaryPhoneNumber';

            this.textMsgNumberSelected = selectedPhoneType === 'MOBILE' ?
              `+${this.countryCode} ${this.primaryPhoneNumber}` : `+${this.countryCode} ${this.secondaryPhoneNumber}`;

            selectedPhoneType === 'MOBILE' ? this.textMsgDropdownControl.setValue('PHONE') :
              this.textMsgDropdownControl.setValue('MOBILE');
          } else {
            this.phoneCallSelectedLabel = selectedPhoneType === 'MOBILE' ?
              'phoneNumber.primaryPhoneNumber' : 'phoneNumber.secondaryPhoneNumber';

            this.phoneCallNumberSelected = selectedPhoneType === 'MOBILE' ?
              `+${this.countryCode} ${this.primaryPhoneNumber}` : `+${this.countryCode} ${this.secondaryPhoneNumber}`;

            selectedPhoneType === 'MOBILE' ? this.phoneCallDropdownControl.setValue('PHONE') :
              this.phoneCallDropdownControl.setValue('MOBILE');
          }
          this.isPhoneNumLoading = false;
        }
      );
  }

  handleError(err: HttpErrorResponse, messageFlag: string): void {
    const obj = { flag: true, messageFlag };

    const errorCodes = (err?.error?.errors) ? err?.error?.errors[0].code.toLowerCase().replaceAll('.', '_') : '';

    if (err.status === this.ERROR_CODE_400 && err.error.errors && errorCodes === 'stepup_auth_expired')
    {
      this.elevateAuthority$().subscribe((isElevated) => {
        if (isElevated && this.isTwoStepVerification && !this.isLocationRestriction) this.toggleMfaCheck(null);
        else if (isElevated && !this.isTwoStepVerification && this.isLocationRestriction) this.changeLocationRestriction(null);
        else this.poprService.createToast(PoprPriority.ERROR, this.twoFactorFailureTemplate);
      });
    }
    else {
      this.hideNotificationPopup.emit(obj);
    }
  }

  //B-676133, hide continue poup and reset values to have page on initial state.
  hidePopup(event: boolean): void {
    this.showPopUp = event;
    if (this.locationRestrictionClicked) {
      this.twoStepVerifyForm.patchValue({ restrictOutsideCountryLogin: !this.restrictionFlag });
    }
    if (this.twoStepVerificationClicked) {
      this.twoStepVerifyForm.patchValue({ mfaOnLogin: !this.mfaFlag });
      this.isTwoSVToggleLoading = false;
    }
    this.twoStepVerifyForm.patchValue({ deliveryChannelPreference: this.defaultDeliveryMethod[0].deliveryMethod });
    this.locationRestrictionClicked = false;
    this.twoStepVerificationClicked = false;
    this.deliveryType = '';
    const maxWidth = 768;
    if (screen.width < maxWidth) {
      this.sharedService.isModalPopupOpen = false;
      this._document.body.style.overflow = 'auto';
    }
  }

  //B-676133, trigger event when continue clicked, and sense button click and call methods accordingly for
  //further processing.
  continue(): void {
    this.closeLoginEdit.emit(false);
    if (this.locationRestrictionClicked) {
      this.changeLocationRestriction(null);
    } else if (this.twoStepVerificationClicked) {
      this.toggleMfaCheck(null);
    } else if (this.contactlinckclicked) {
      this.sharedService.setSelectedRoute('contact');
      this.router.navigate(['/contact']);
    }
    else {
      this.changeMFAPrefrenceType(this.deliveryType);
    }
  }

  /**
   * Elevate user's authority to allow save/update to proceed
   *
   * @return true if user authority elevated, false otherwise
   */
  elevateAuthority$(): Observable<boolean> {
    const modal = this.poprService.createModal(TwoFactorComponent);
    return modal.component$().pipe(
      switchMap(comp => comp.isElevatedAuthority$()),
      defaultIfEmpty(false),
      finalize(() => modal.close())
    );
  }

  ngAfterViewInit(): void {
    if (this.twosvFlag) {
      const headerOffset = 63; //shf header
      const elementToFocus = this.el.nativeElement.querySelector('[id=\'check5.1\']');
      const elementToScroll = this.el.nativeElement.querySelector('[id=\'verification-title\']');
      const currElemRect = elementToScroll?.getBoundingClientRect();
      const currentElemPosition = window.scrollY + currElemRect?.top;
      const scrollY = currentElemPosition - headerOffset;
      setTimeout(() => {
        window.scrollTo(0, scrollY);
        elementToFocus?.focus();
      }, 1000);
    }
  }

  revalidateMfa(isLoginEmailUpdated?: boolean): void {
    let queryParams = {};
    this.activatedRoute.queryParamMap
      .subscribe((params) => {
        queryParams = params;
      });
    this.deliveryType = isLoginEmailUpdated ? 'EMAIL' : this.deliveryType;
    this.mfaFlag = false;
    this.mfaPreferencesService.updateMFAOnLogin(this.mfaFlag, queryParams).subscribe({
      next: () => {
        this.twoStepVerifyForm.patchValue({ mfaOnLogin: this.mfaFlag });
        this.isTwoFAEnabled = false;
        this.verifyPinRequest = {
          deliveryMethod: this.deliveryType,
          preferredDeliveryType: (this.deliveryType === 'EMAIL') ? 'PERSONALEMAIL' : 'PHONE'
        };
        isLoginEmailUpdated ? this.continueVerifyFlow.emit(true) : this.sendPinRequest();
      },
      error: (error) => {
        this.gdlService.captureGdlErrorMessages(this.gdlServerType, error, this.gdlContextPutType);
        this.disableMfa();
      }
    });
  }

  sendPinRequest(): void {
    let queryParams = {};
    this.activatedRoute.queryParamMap
      .subscribe((params) => {
        queryParams = params;
      });
    this.sendPinService.requestPin(this.verifyPinRequest).subscribe({
      next: () => {
        this.openPinPopup(queryParams);
      },
      error: () => {
        this.disableMfa();
      }
    });
  }

  openPinPopup(queryParams: any): void {
    const poprRef = this.popr2Service.createModal(
      EnterPinComponent,
      { priority: Popr2Level.NONE, dimension: '.fdx-c-dialog--narrow.fdx-c-dialog--condensed' }
    );

    poprRef.registerOnClose(this.disableMfa.bind(this));

    poprRef.open((comp: EnterPinComponent) => {
      comp.method = this.deliveryType;
      comp.useDiffMethodLink = false;
       this.contactDetails?.filter((channel: any) => channel.deliveryMethod === this.deliveryType)
       .map((item: any) => comp.value = item.value);
      comp.apiSuccess.subscribe(() => {
        this.mfaPreferencesService.updateUserMFAPreferences(this.deliveryType).subscribe({
          next: () => {
            this.mfaFlag = true;
            this.isTwoFAEnabled = true;
            this.gdlService.captureInteractionEvent('verification', this.deliveryType);
            poprRef.close();
            this.mfaPreferencesService.updateMFAOnLogin(this.mfaFlag, queryParams).subscribe({
              next: () => {
                this.twoStepVerifyForm.patchValue({ mfaOnLogin: this.mfaFlag });
                this.hideSuccessNotificationPopup.emit(true);
                this.sessionStorageService.setItem('deliveryChannelPreference', this.deliveryType);
                this.patchDeliveryChannelPreference(this.deliveryType);
                this.deliveryMethod = this.deliveryType;
              },
              error: () => {
                this.disableMfa();
              }
            });
          },
          error: (error) => {
            this.gdlService.captureGdlErrorMessages(this.gdlServerType, error, this.gdlContextPutType);
            this.disableMfa();
          }
        });
      });
    });
  }

  disableMfa(): void {
    if (!this.twoStepVerifyForm.controls['mfaOnLogin'].value) {
      this.mfaFlag = false;
      this.isTwoFAEnabled = false;
      this.twoStepVerifyForm.patchValue({ mfaOnLogin: this.mfaFlag });
      this.mfaUpdate();
    }
  }

  mfaUpdate(): void {
    let successMsg;
    const messageKey = 'successNotification.twoSVDisableDescription';
    this.translateService.get(messageKey).subscribe((translatedMsg) => {
      successMsg = translatedMsg;
    });
    this.toastMessage2SV(successMsg, Popr2Level.SUCCESS);
    this.sessionStorageService.setItem('mfaToggleStatus', this.mfaFlag);
    this.isTwoStepVerification = false;
    this.isTwoFAEnabled=this.mfaFlag;
    this.hideDefaultverifyandTrustedDevice.emit(this.mfaFlag);
    const mfaLogin = this.twoStepVerifyForm.controls['mfaOnLogin'].value ? this.gdlMfaSwitchOn : this.gdlMfaSwitchOff;
    this.gdlService.captureInteractionEvent(this.gdlMfaLogin, mfaLogin);
  }
}
